import { render, staticRenderFns } from "./Bugetare.vue?vue&type=template&id=d40ae724"
import script from "./Bugetare.vue?vue&type=script&lang=js"
export * from "./Bugetare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports